export function footerNavigation() {
    document.addEventListener("DOMContentLoaded", function () {
        const navHeaders = document.querySelectorAll(".nav-header");

        function isDesktop() {
            return window.innerWidth >= 1024;
        }

        function toggleNav(header) {
            if (isDesktop()) return;

            const navList = header.nextElementSibling;
            const toggle = header.querySelector(".nav-toggle");

            navHeaders.forEach((otherHeader) => {
                if (otherHeader !== header) {
                    const otherNavList = otherHeader.nextElementSibling;
                    const otherToggle = otherHeader.querySelector(".nav-toggle");

                    otherNavList.classList.remove("active");
                    otherToggle.classList.remove("active");
                    otherToggle.textContent = "+";
                }
            });


            navList.classList.toggle("active");
            toggle.classList.toggle("active");

            if (navList.classList.contains("active")) {
                toggle.textContent = "×";
            } else {
                toggle.textContent = "+";
            }
        }

        function resetMobileState() {
            if (isDesktop()) {

                document.querySelectorAll(".nav-list").forEach((list) => {
                    list.classList.remove("active");
                });

                document.querySelectorAll(".nav-toggle").forEach((toggle) => {
                    toggle.classList.remove("active");
                    toggle.textContent = "+";
                });
            } else {
                
                document.querySelectorAll(".nav-list").forEach((list) => {
                    list.classList.remove("active");
                });

                document.querySelectorAll(".nav-toggle").forEach((toggle) => {
                    toggle.classList.remove("active");
                    toggle.textContent = "+";
                });
            }
        }

        navHeaders.forEach((header) => {
            header.addEventListener("click", () => toggleNav(header));
        });


        let resizeTimer;
        window.addEventListener("resize", function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(resetMobileState, 250);
        });

        resetMobileState();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/footerNavigation.js